import { ROUTE_CATALOG } from '../config/route-catalog.config';
import { normalizeKey } from './text.utils';

/** Clave `módulo:sección:página` (normalizada) con la que se busca una ruta en el catálogo. */
export function routeLookupKey(moduleIdentifier: string, sectionIdentifier: string, pageIdentifier: string): string {
    return `${normalizeKey(moduleIdentifier)}:${normalizeKey(sectionIdentifier)}:${normalizeKey(pageIdentifier)}`;
}

const ROUTE_LINK_BY_KEY: ReadonlyMap<string, string> = new Map(
    ROUTE_CATALOG.map((entry) => [
        routeLookupKey(entry.moduleIdentifier, entry.sectionIdentifier, entry.pageIdentifier),
        entry.routerLink,
    ]),
);

/** Ruta Angular de una página de Identity según el catálogo, o `null` si no existe (página huérfana). */
export function catalogRouteLink(moduleIdentifier: string, sectionIdentifier: string, pageIdentifier: string): string | null {
    return ROUTE_LINK_BY_KEY.get(routeLookupKey(moduleIdentifier, sectionIdentifier, pageIdentifier)) ?? null;
}
